import { render, staticRenderFns } from "./create-testQuestionUs.vue?vue&type=template&id=e4c6243a&scoped=true&"
import script from "./create-testQuestionUs.vue?vue&type=script&lang=ts&"
export * from "./create-testQuestionUs.vue?vue&type=script&lang=ts&"
import style0 from "./create-testQuestionUs.vue?vue&type=style&index=0&id=e4c6243a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c6243a",
  null
  
)

export default component.exports